// Monthly exclusion checks page: "Set all blank dates to" copies the chosen date into every empty
// date-checked field. Bound once on document so it keeps working across Turbolinks page visits.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-exclusion-fill-button]');
  if (!button) return;

  const form = button.closest('form');
  const source = form && form.querySelector('[data-exclusion-fill-date]');
  if (!source || !source.value) return;

  form.querySelectorAll('[data-exclusion-date]').forEach((input) => {
    if (!input.value) input.value = source.value;
  });
});
